<template>
  <div>
    <div class="animated fadeIn fast" v-if="hasAccounts">
      <div
        class="block"
        v-for="(account, id, index) in appsByAccount"
        :key="id"
      >
        <hr v-if="index > 0" />

        <h1 class="title title-account">
          {{ account.display_name || id }}
          <div class="tags" v-if="account.roles">
            <span
              class="tag is-info"
              v-for="(role, roleIndex) in account.roles"
              :key="roleIndex"
              >{{ $t(`types.roles.${role}`) }}</span
            >
          </div>
          <!-- <a class="edit-app" v-if="isDeveloper(account.roles)">
            <span class="icon is-small">
              <i class="mdi mdi-settings-outline"></i>
            </span>
          </a>-->
        </h1>

        <div class="columns">
          <div
            class="column is-one-third"
            v-for="app in account.applications"
            :key="app.id"
          >
            <application-card
              :app="app"
              :is-developer="isDeveloper(account.roles)"
              :is-developer-or-spectator="
                isDeveloperOrSpectatorForApp(account.roles)
              "
              :user-type="userType"
              :is-crash-reporting-enabled="app.is_crash_reporting_enabled"
              @go-to-app="loadApp"
            >
              <application-config
                :id="app.id"
                :secret="app.secret"
              ></application-config>
            </application-card>
          </div>
        </div>
      </div>
    </div>

    <section v-else>
      <p>{{ $t('applications.errors.no_apps') }}</p>
      <router-link to="/logout" class="button is-primary">{{
        $t('applications.buttons.logout')
      }}</router-link>
    </section>
    <action-required-modal
      :is-active="actionRequiredModal.isActive"
      :title="$t('applications.action_required.modal.title')"
      :text="$t('applications.action_required.modal.text')"
      :button="$t('applications.action_required.modal.button')"
      @close-modal="closeActionRequiredModal"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ActionRequiredModal from './ActionRequiredModal';
import Clipboard from 'clipboard/dist/clipboard';
import notifications from 'services/Notifications';
import ApplicationConfig from 'components/application-config';
import { ApplicationCard } from 'components/cards';
import { configs } from 'config';

export default {
  name: 'ApplicationIndex',

  components: {
    ApplicationCard,
    ApplicationConfig,
    ActionRequiredModal,
  },

  data() {
    return {
      actionRequiredModal: {
        isActive: false,
      },
    };
  },

  computed: {
    ...mapState('account', ['appsByAccount', 'userType', 'appId']),
    ...mapState('application', ['apps']),
    hasAccounts() {
      return Object.keys(this.appsByAccount).length > 0;
    },
    activeApp() {
      return this.apps.find(app => app.id === this.activeAppId);
    },
  },

  mounted() {
    const clipboard = new Clipboard('.code-line [data-clipboard-text]');

    clipboard.on('success', e =>
      notifications.add(`Copied ${e.trigger.name}`, 'success')
    );

    clipboard.on('error', e =>
      notifications.add(`Unable to copy ${e.trigger.name}`, 'warning')
    );

    if (this.userType === 'journeys') {
      if (!this.isDeveloperOrSpectator()) {
        this.loadApp(this.appId);
      } else if (configs().USER_TYPE_TABS.includes('business')) {
        this.openActionRequiredModal();
      }
    }
  },

  methods: {
    loadApp(id) {
      this.$store.dispatch('application/showApp', id);
    },
    isDeveloper(roles) {
      return roles.includes('developer');
    },
    isDeveloperOrSpectator() {
      for (const [key, value] of Object.entries(this.appsByAccount)) {
        if (
          value.roles.includes('developer') ||
          value.roles.includes('spectator')
        )
          return true;
      }
      return false;
    },
    isDeveloperOrSpectatorForApp(roles) {
      return roles.includes('developer') || roles.includes('spectator');
    },
    openActionRequiredModal() {
      this.actionRequiredModal.isActive = true;
    },
    closeActionRequiredModal() {
      this.actionRequiredModal.isActive = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

$column-gap: 0.5rem;

.columns {
  flex-wrap: wrap;
  margin: -$column-gap;
}

.column {
  padding: $column-gap;
}

.title-account {
  display: flex;
  align-items: center;

  .tags {
    margin-left: 1rem;
  }

  .tag {
    background-color: transparent;
    background-image: linear-gradient(to bottom, #83bcff, #4a90e2);
    font-weight: 400;
  }
}

hr {
  margin: 2.5rem 0;
}

.edit-app {
  font-size: 0.875rem;
  color: rgba($black, 0.4);
  margin-left: 1rem;
  transform: translateY(1px);
  transition: $transition;

  &:hover {
    color: rgba($black, 0.5);
  }
}
</style>
